import { render, staticRenderFns } from "./brand-popular-models.vue?vue&type=template&id=68232942&scoped=true&"
import script from "./brand-popular-models.vue?vue&type=script&lang=js&"
export * from "./brand-popular-models.vue?vue&type=script&lang=js&"
import style0 from "./brand-popular-models.vue?vue&type=style&index=0&id=68232942&scoped=true&lang=css&"
import style1 from "./brand-popular-models.vue?vue&type=style&index=1&id=68232942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68232942",
  null
  
)

export default component.exports